/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */
import {useMemo} from 'react';
import {get} from '@ion/core/src/environment/environment';
import {hasRole} from '@ion/core/src/security/helpers';
import {safeJSONParse} from '@ion/core/src/utils/JSONUtils';
import {useAuthenticatedUser} from '../admin/users/useAuthenticatedUser';

/**
 * Determines if the currently authenticated user can access the schedule data
 * sync option to force update a device.
 *
 * Currently, a user must have a role of Calamp Support.
 */
export const useScheduleDataSync = (): boolean => {
  const {roles}       = useAuthenticatedUser() || {};
  const userHasAccess = useMemo(() => {
    const calAmpRoles      = safeJSONParse(get('vbusRoles'));
    const calAmpSuportRole = [calAmpRoles?.[1]];
    return hasRole(roles, calAmpSuportRole);
  }, [roles]);

  return userHasAccess;
};

export default useScheduleDataSync;
